import { FlowchartLinkAttributeOperator, ObservationPermittedDataType } from '@treetop/shared/model';

import { LinkValueInputType, MappedLinkValueType } from './MapperTypes';

export class ObservationDataTypeMapper {
  static mapTypeToSelect(type: ObservationPermittedDataType, isMultiSelect?: boolean, isOrdered?: boolean): MappedLinkValueType {
    switch (type) {
      case ObservationPermittedDataType.Quantity:
        return {
          selects: [
            { value: '<', translationText: 'Flowchart.Links.Value.SmallerThan', operator: FlowchartLinkAttributeOperator.SmallerThan },
            {
              value: '<=',
              translationText: 'Flowchart.Links.Value.SmallerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.SmallerThanOrEquals,
            },
            { value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals },
            {
              value: '>=',
              translationText: 'Flowchart.Links.Value.BiggerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.BiggerThanOrEquals,
            },
            { value: '>', translationText: 'Flowchart.Links.Value.BiggerThan', operator: FlowchartLinkAttributeOperator.BiggerThan },
            { value: 'Between', translationText: 'Flowchart.Links.Value.Range', operator: FlowchartLinkAttributeOperator.Between },
          ],
          inputType: LinkValueInputType.Number,
          payloadAttribute: 'numericalValue',
        };
      case ObservationPermittedDataType.CodeableConcept:
        if (isOrdered && !isMultiSelect) {
          return {
            selects: [
              { value: '<', translationText: 'Flowchart.Links.Value.SmallerThan', operator: FlowchartLinkAttributeOperator.SmallerThan },
              {
                value: '<=',
                translationText: 'Flowchart.Links.Value.SmallerThanOrEquals',
                operator: FlowchartLinkAttributeOperator.SmallerThanOrEquals,
              },
              { value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals },
              {
                value: '>=',
                translationText: 'Flowchart.Links.Value.BiggerThanOrEquals',
                operator: FlowchartLinkAttributeOperator.BiggerThanOrEquals,
              },
              { value: '>', translationText: 'Flowchart.Links.Value.BiggerThan', operator: FlowchartLinkAttributeOperator.BiggerThan },
            ],
            inputType: LinkValueInputType.Table,
            payloadAttribute: 'codeableConceptValueArray',
          };
        } else
          return {
            selects: [{ value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals }],
            inputType: LinkValueInputType.Table,
            payloadAttribute: 'codeableConceptValueArray',
          };
      case ObservationPermittedDataType.Boolean:
        return {
          selects: [{ value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals }],
          inputType: LinkValueInputType.Boolean,
          payloadAttribute: 'booleanValue',
        };
      case ObservationPermittedDataType.Integer:
        return {
          selects: [
            { value: '<', translationText: 'Flowchart.Links.Value.SmallerThan', operator: FlowchartLinkAttributeOperator.SmallerThan },
            {
              value: '<=',
              translationText: 'Flowchart.Links.Value.SmallerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.SmallerThanOrEquals,
            },
            { value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals },
            {
              value: '>=',
              translationText: 'Flowchart.Links.Value.BiggerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.BiggerThanOrEquals,
            },
            { value: '>', translationText: 'Flowchart.Links.Value.BiggerThan', operator: FlowchartLinkAttributeOperator.BiggerThan },
            { value: 'Between', translationText: 'Flowchart.Links.Value.Range', operator: FlowchartLinkAttributeOperator.Between },
          ],

          inputType: LinkValueInputType.Number,
          payloadAttribute: 'numericalValue',
        };
      case ObservationPermittedDataType.Ratio:
        return {
          selects: [
            { value: '<', translationText: 'Flowchart.Links.Value.SmallerThan', operator: FlowchartLinkAttributeOperator.SmallerThan },
            {
              value: '<=',
              translationText: 'Flowchart.Links.Value.SmallerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.SmallerThanOrEquals,
            },
            { value: '=', translationText: 'Flowchart.Links.Value.Equals', operator: FlowchartLinkAttributeOperator.Equals },
            {
              value: '>=',
              translationText: 'Flowchart.Links.Value.BiggerThanOrEquals',
              operator: FlowchartLinkAttributeOperator.BiggerThanOrEquals,
            },
            { value: '>', translationText: 'Flowchart.Links.Value.BiggerThan', operator: FlowchartLinkAttributeOperator.BiggerThan },
            { value: 'Between', translationText: 'Flowchart.Links.Value.Range', operator: FlowchartLinkAttributeOperator.Between },
          ],
          inputType: LinkValueInputType.Number,
          payloadAttribute: 'numericalValue',
        };
    }
  }
}
